module.exports = __webpack_public_path__ + "img/about.2608927d.png";